module.exports = __webpack_public_path__ + "media/Loops Drums.ddb7847a.wav";